import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createHoliday } from "./api";
import { formatDateForAPI, invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  console.log(values);
  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
    date: formatDateForAPI(values.date) || null,
  };
}

export function useCreateHoliday() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createHoliday({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Holiday Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
